import { Order } from "@client/stores";

export function getTotalNumberOfProducts(
	order: Order,
	filterCanceled?: boolean
) {
	return order.products.reduce(
		(sum, product) =>
			filterCanceled
				? sum +
				  product?.order_details?.quantity -
				  product?.order_details?.qtyCanceled
				: sum + product?.order_details?.quantity,
		0
	);
}
